import { render, staticRenderFns } from "./MenuTypeDelete.vue?vue&type=template&id=75033ed9&scoped=true"
import script from "./MenuTypeDelete.vue?vue&type=script&lang=js"
export * from "./MenuTypeDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75033ed9",
  null
  
)

export default component.exports